import WriteOffConfirm from '@/api/stock/write-off-confirm'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branch_id: [],
  is_confirm: 0,
  dateRange: [
    moment()
      .startOf('M')
      .format('DD-MM-YYYY'),
    moment()
      .endOf('M')
      .format('DD-MM-YYYY')
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_STATUS(state, date) {
    state.is_confirm = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          is_confirm: context.state.is_confirm,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return WriteOffConfirm.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return WriteOffConfirm.store(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await WriteOffConfirm.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async checkReceiveMonthDiffMonthWriteOff(context, data) {
    return await WriteOffConfirm.checkReceiveMonthDiffMonthWriteOff(data)
  }
}
